import { errorInfoAsString, errorMessageAsString } from "@/modules/error/errorToString.ts";
import { isMessageDescriptor, type Localizable } from "@/modules/l10n/getTransText.ts";
import { useLingui } from "@lingui/react/macro";
import { isObject } from "@warrenio/utils/isObject";
import type { ReactNode } from "react";

export function LocalizedErrorMessage({ error }: { error: unknown }): ReactNode {
    const { i18n } = useLingui();
    let message;
    if (isObject(error) && "localeMessage" in error) {
        try {
            const localeMessage = error.localeMessage as Localizable;
            if (localeMessage != null) {
                /** It's either a descriptor (need to convert), or a string or `<Trans>` React node (which can be rendered directly) */
                message = isMessageDescriptor(localeMessage) ? i18n.t(localeMessage) : localeMessage;
            }
        } catch (te) {
            console.error(`Error while localizing error message of ${errorMessageAsString(error)}`, te);
        }
    }

    message ??= errorMessageAsString(error);
    const info = errorInfoAsString(error);
    return (
        <>
            {message}
            {info && (
                <>
                    {" "}
                    <span className="text-muted">({info})</span>
                </>
            )}
        </>
    );
}
